<template>
  <v-app>
    <v-container fluid class="pa-0 fill-height d-flex" v-if="registering">
      <v-row no-gutters class="fill-height">
        <v-col cols="12" md="4" class="left-side d-flex justify-center">
          <h1 class="white--text">Nossa metodologia, seu sucesso!</h1>
        </v-col>
        <v-col
          cols="12"
          md="8"
          class="right-side d-flex align-center justify-center"
        >
          <v-card class="form-card" elevation="0">
            <v-card-title
              class="d-flex align-center justify-center mt-0 pt-0 mb-0 pb-0"
              dense
            >
              <v-img
                src="@/assets/images/connect/partner/connect-logo.webp"
                contain
                height="250"
                class="mt-0 pt-0 mb-0 pb-0"
              ></v-img>
            </v-card-title>
            <v-card-text style="min-height: 55vh">
              <v-form
                ref="form"
                v-model="valid"
                elevation="0"
                @submit.prevent="nextStep"
              >
                <v-stepper
                  v-model="step"
                  class="stepper"
                  elevation="0"
                  style="max-width: 100%"
                  dense
                >
                  <v-stepper-header
                    elevation="0"
                    class="d-flex align-center justify-center"
                  >
                    <span class="grey--text poppins">Let's do it!</span>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 1"
                      step="1"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 2"
                      step="2"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 3"
                      step="3"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 4"
                      step="4"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 5"
                      step="5"
                    ></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items elevation="0">
                    <v-stepper-content step="1">
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="1">
                          <v-card-text>
                            <h5 class="grey--text">1º Informações pessoais</h5>
                            <p class="mt-2">
                              <strong class="grey--text">A.</strong>
                              <strong class="primary900 poppins">
                                Informe seus dados de acesso.</strong
                              ><br />
                            </p>
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <custom-input
                                  v-if="step === 1 && subStep === 1"
                                  label="Nome Completo"
                                  placeholder="Jhon Doe Smith"
                                  hint="ex: Jhon Doe Smith"
                                  v-model="form.fullName"
                                  :rules="[
                                    (v) => !!v || 'Selecione uma opção.',
                                  ]"
                                  :currentValue="form.fullName"
                                  :customRules="rules.required"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="6">
                                <debounced-input
                                  v-if="step === 1 && subStep === 1"
                                  placeholder="jhon@doe.com"
                                  hint="ex: email@domain.com"
                                  v-model="form.email"
                                  label="Email"
                                  :rules="rules.email"
                                  :currentValue="form.email"
                                  :customRules="rules.required"
                                  :errorMessage="emailMessage"
                                  @search="checkEmail"
                                ></debounced-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <custom-input
                                  v-if="step === 1 && subStep === 1"
                                  required
                                  v-model="form.password"
                                  class="mt-4"
                                  label="Senha"
                                  placeholder="Senha"
                                  :errorMessage="errorMessage"
                                  :type="showPassword ? 'text' : 'password'"
                                  :customRule="rules.password"
                                  :currentValue="form.password"
                                  :appendIcon="
                                    showPassword ? 'mdi-eye' : 'mdi-eye-closed'
                                  "
                                  @iconClick="showPassword = !showPassword"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="6" class="pl-1">
                                <custom-input
                                  v-if="step === 1 && subStep === 1"
                                  required
                                  v-model="password"
                                  class="mt-4"
                                  label="Confirmar senha"
                                  placeholder="Confirmar senha"
                                  :errorMessage="errorMessage"
                                  :type="showPassword ? 'text' : 'password'"
                                  :customRule="rules.password"
                                  :currentValue="password"
                                  :appendIcon="
                                    showPassword ? 'mdi-eye' : 'mdi-eye-closed'
                                  "
                                  @iconClick="showPassword = !showPassword"
                                ></custom-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="2">
                                <custom-country-selector
                                  @onInput="(value) => (ddi = value)"
                                />
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-masked-input
                                  v-if="step === 1 && subStep === 1"
                                  required
                                  v-model="form.phone"
                                  ref="emailInput"
                                  label="Telefone"
                                  placeholder="(99)12345-6789"
                                  hint="ex: (99)12345-6789"
                                  mask="(##)#####-####"
                                  :currentValue="form.phone"
                                ></custom-masked-input>
                              </v-col>
                              <v-col cols="12" md="6"
                                ><custom-masked-input
                                  v-if="step === 1 && subStep === 1"
                                  v-model="birthDate"
                                  label="Data de nascimento"
                                  placeholder="Dia/Mês/Ano"
                                  hint="ex: 25/12/2000"
                                  mask="##/##/####"
                                  :currentValue="birthDate"
                                  :customRule="rules.validDate"
                                ></custom-masked-input>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-card-text>
                            <h5 class="grey--text">Informações pessoais</h5>
                            <p class="mt-2">
                              <strong class="grey--text">B.</strong>
                              <strong class="primary900 poppins"
                                >Dados do responsável legal</strong
                              ><br />
                            </p>
                            <v-row dense class="mt-2">
                              <v-col cols="12" md="6">
                                <custom-input
                                  v-model="form.legalGuardian.name"
                                  v-if="step === 1 && subStep === 2"
                                  label="Nome completo do responsável"
                                  placeholder="Informe o nome do seu responsável legal"
                                  :currentValue="form.legalGuardian.name"
                                  :customRule="rules.requiredField"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="6">
                                <custom-input
                                  v-if="step === 1 && subStep === 2"
                                  required
                                  v-model="form.legalGuardian.email"
                                  ref="emailInput"
                                  label="Email"
                                  placeholder="Email"
                                  hint="ex: email@domain.com"
                                  :customRule="rules.email"
                                  :currentValue="form.legalGuardian.email"
                                >
                                </custom-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="2">
                                <custom-country-selector
                                  @onInput="
                                    (value) => (legalGuardianddi = value)
                                  "
                                />
                              </v-col>
                              <v-col cols="12" md="4" sm="4">
                                <custom-masked-input
                                  v-if="step === 1 && subStep === 2"
                                  v-model="form.legalGuardian.phone"
                                  label="Número de telefone do responsável"
                                  placeholder="(11)99999-9999"
                                  hint="ex: (11)1234-5678"
                                  :mask="'(##)#####-####'"
                                  :currentValue="form.legalGuardian.phone"
                                ></custom-masked-input>
                              </v-col>
                              <v-col cols="12" md="6" sm="6">
                                <custom-masked-input
                                  v-if="step === 1 && subStep === 2"
                                  v-model="form.legalGuardian.document"
                                  label="Documento do responsável"
                                  placeholder="123.456.789-10"
                                  :mask="'###.###.###-##'"
                                  :currentValue="form.legalGuardian.document"
                                  :customRule="rules.document"
                                ></custom-masked-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="6" sm="6">
                                <custom-masked-input
                                  v-if="step === 1 && subStep === 2"
                                  v-model="form.legalGuardian.birthDate"
                                  label="Data de nascimento do responsável"
                                  placeholder="Dia/Mês/Ano"
                                  hint="ex: 25/12/1960"
                                  mask="##/##/####"
                                  :currentValue="form.legalGuardian.birthDate"
                                  :customRule="rules.validDate"
                                ></custom-masked-input>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div>Grau de parentesco</div>
                                <div class="d-flex align-center">
                                  <v-select
                                    v-if="step === 1 && subStep === 2"
                                    v-model="form.legalGuardian.kinship"
                                    dense
                                    required
                                    background-color="#F1F3F5"
                                    :rules="rules.required"
                                    :items="parentGrades"
                                    :item-value="`value`"
                                    :item-text="`text`"
                                    style="border-radius: 5px"
                                  ></v-select>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                          <v-card-text>
                            <h5 class="grey--text">Informações pessoais</h5>
                            <p class="mt-2">
                              <strong class="grey--text"
                                >{{ form.underAge ? "C" : "B" }}.</strong
                              >
                              <strong class="primary900 poppins"
                                >Qual é o seu endereço completo ?</strong
                              ><br />
                            </p>
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <debounced-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="zipCodeInput"
                                  label="CEP"
                                  placeholder="12345678"
                                  hint="Apenas números"
                                  v-model="form.address.zipCode"
                                  :currentValue="form.address.zipCode"
                                  @search="getAddressByZipCode"
                                ></debounced-input>
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="streetInput"
                                  label="Rua"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Nome da rua'
                                  "
                                  hint="ex: Avenida Epitácio Pessoa"
                                  v-model="form.address.street"
                                  :readonly="readOnly"
                                  :currentValue="form.address.street"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="2">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="numberInput"
                                  label="Número"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Número da resicência'
                                  "
                                  hint="ex: 1075"
                                  v-model="form.address.number"
                                  :readonly="readOnly"
                                  :currentValue="form.address.number"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="2">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="numberInput"
                                  label="Complemento"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Complemento'
                                  "
                                  hint="ex: casa"
                                  v-model="form.address.complement"
                                  :readonly="readOnly"
                                  :currentValue="form.address.complement"
                                  :required="false"
                                ></custom-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <v-col cols="12" md="4">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="neighboorhoodInput"
                                  label="Bairro"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Nome do bairro'
                                  "
                                  hint="ex: Centro"
                                  v-model="form.address.neighboorhood"
                                  :readonly="readOnly"
                                  :currentValue="form.address.neighboorhood"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  ref="cityInput"
                                  label="Cidade"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Nome da cidade'
                                  "
                                  hint="ex: João Pessoa"
                                  v-model="form.address.city"
                                  :readonly="readOnly"
                                  :currentValue="form.address.city"
                                ></custom-input>
                              </v-col>
                              <v-col cols="12" md="4">
                                <custom-input
                                  v-if="step === 1 && subStep === 3"
                                  label="Estado"
                                  ref="stateInput"
                                  :placeholder="
                                    loadingAddress
                                      ? 'Carregando...'
                                      : 'Sigla do Estado'
                                  "
                                  hint="ex: PB"
                                  v-model="form.address.province"
                                  :readonly="readOnly"
                                  :currentValue="form.address.province"
                                ></custom-input>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="1">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">
                              2º Experiência profissional
                            </h5>
                            <p class="mt-2">
                              <strong class="grey--text">A.</strong>
                              <strong class="primary900 poppins">
                                Por quanto tempo você atuou como professor de
                                inglês?</strong
                              >
                            </p>
                            <v-row dense>
                              <v-radio-group
                                v-if="step === 2 && subStep === 1"
                                row
                                v-model="
                                  form.professionalExperience.yearsOfExperience
                                "
                                :rules="rules.required"
                              >
                                <v-col
                                  cols="12"
                                  md="6"
                                  v-for="(
                                    experience, index
                                  ) in experiencesLevelsOptions"
                                  :key="index"
                                >
                                  <v-radio
                                    :label="experience.text"
                                    :value="experience.value"
                                  ></v-radio>
                                </v-col>
                              </v-radio-group>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">
                              2º Experiência profissional
                            </h5>
                            <p class="mt-2">
                              <strong class="grey--text">B.</strong>
                              <strong class="primary900 poppins">
                                Quais instituições você lecionou?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Escolha todas as que se aplicam)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(
                                  institution, index
                                ) in schoolsTypesOptions"
                                :key="index"
                                class="d-flex align-center justify-start"
                              >
                                <v-checkbox
                                  v-if="step === 2 && subStep === 2"
                                  v-model="
                                    form.professionalExperience.institutions
                                  "
                                  :label="institution.text"
                                  :value="institution.value"
                                  :disabled="
                                    disableCheckInstitutions &&
                                    institution.value.toUpperCase() !==
                                      'UNEXPERIENCED'
                                  "
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">
                              2º Experiência profissional
                            </h5>
                            <p class="mt-2">
                              <strong class="grey--text">C.</strong>
                              <strong class="primary900 poppins">
                                Você possui experiência de ensino fora do
                                país?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Em que contexto?)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(
                                  options, index
                                ) in teachingExperiencieAbroadOptions"
                                :key="index"
                                class="d-flex align-center justify-start"
                              >
                                <v-checkbox
                                  v-model="
                                    form.professionalExperience
                                      .teachingExperiencieAbroad
                                  "
                                  :value="options.value"
                                  :label="options.text"
                                  :disabled="
                                    disableCheckExperienceAbroad &&
                                    options.value.toUpperCase() !==
                                      'UNEXPERIENCED'
                                  "
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">
                              2º Experiência profissional
                            </h5>
                            <p class="mt-2">
                              <strong class="grey--text">D.</strong>
                              <strong class="primary900 poppins">
                                Possui certificado de proficiência em
                                inglês?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Escolha todas as que se aplicam)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(options, index) in certificatesOptions"
                                :key="index"
                                class="d-flex align-center justify-start"
                              >
                                <v-checkbox
                                  v-if="step === 2 && subStep === 4"
                                  :value="options.value"
                                  :label="options.text"
                                  v-model="
                                    form.professionalExperience.certificateType
                                  "
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row
                              dense
                              v-if="
                                form.professionalExperience.certificateType
                                  .length > 0 &&
                                !form.professionalExperience.certificateType.includes(
                                  'dont_have'
                                )
                              "
                              ><v-col cols="12" md="6">
                                <custom-file-input
                                  label="Anexe seu(s) certificado(s)"
                                ></custom-file-input>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="1">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">3º Motivação</h5>
                            <p class="mt-2">
                              <strong class="grey--text">A.</strong>
                              <strong class="primary900 poppins">
                                O que te motiva a se tornar um professor
                                licenciado?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Escolha todas as que se aplicam)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(options, index) in expectationOptions"
                                :key="index"
                                class="d-flex align-center justify-start"
                              >
                                <v-checkbox
                                  v-model="form.motivation.expectation"
                                  :value="options.value"
                                  :label="options.text"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">3º Motivação</h5>
                            <p class="mt-2">
                              <strong class="grey--text">B.</strong>
                              <strong class="primary900 poppins">
                                Quais são suas expectativas em relação às
                                aulas?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Escolha todas as que se aplicam)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(
                                  options, index
                                ) in personalExpectationOptions"
                                :key="index"
                                class="d-flex align-center justify-start ma-0 pa-0"
                              >
                                <v-checkbox
                                  v-if="step === 3 && subStep === 2"
                                  v-model="form.motivation.personalExpectation"
                                  :value="options.value"
                                  :label="options.text"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="1">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">
                              4º Habilidade e metodologia
                            </h5>
                            <p class="mt-2">
                              <strong class="grey--text">A.</strong>
                              <strong class="primary900 poppins">
                                Quais áreas de ensino em inglês você se sente
                                mais confortável dando aula?</strong
                              ><br />
                              <span class="primary900 poppins"
                                >(Escolha todas as que se aplicam)</span
                              >
                            </p>
                            <v-row dense>
                              <v-col
                                cols="12"
                                md="6"
                                v-for="(options, index) in englishAreas"
                                :key="index"
                                class="d-flex align-center justify-start ma-0 pa-0"
                              >
                                <v-checkbox
                                  v-if="step === 4 && subStep === 1"
                                  v-model="form.motivation.englishAreas"
                                  :value="options.value"
                                  :label="options.text"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row dense>
                              <small
                                v-if="displayError"
                                style="background-clip: text; color: red"
                                >Selecione ao menos uma opção</small
                              >
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="1">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">5º Disponibilidade</h5>
                            <p class="mt-2">
                              <strong class="grey--text">A.</strong>
                              <strong class="primary900 poppins">
                                Quais formatos de turma você gostaria de
                                ensinar? </strong
                              ><br />
                            </p>

                            <v-row dense>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="6"
                                  class="d-flex align-center justify-start"
                                  v-for="(item, index) in classPreference"
                                  :key="index"
                                >
                                  <v-checkbox
                                    v-model="form.preferedClassType"
                                    class="mt-3"
                                    :label="item.text"
                                    :value="item.value"
                                  >
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                      <v-stepper v-model="subStep">
                        <v-stepper-content step="2">
                          <v-card-text elevation="0">
                            <h5 class="grey--text">5º Disponibilidade</h5>
                            <p class="mt-2">
                              <strong class="grey--text">B.</strong>
                              <strong class="primary900 poppins">
                                Informe TODOS os seus horários disponíveis na
                                semana para realizar as aulas: </strong
                              ><br />
                            </p>

                            <v-row dense>
                              <v-row dense>
                                <v-col cols="12" md="4">
                                  <v-select
                                    v-model="form.perClass"
                                    label="Quantos minutos de aula?"
                                    :items="minutes"
                                    :item-text="`text`"
                                    :item-value="`value`"
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <v-col cols="12" md="12">
                                <WeeklyTable
                                  ref="weeklyTable"
                                  v-if="step === 5 && subStep === 2"
                                  style="width: 100%"
                                  :values="form.available"
                                  :perClass="form.perClass"
                                  :interval="form.interval"
                                  :inAHalf="true"
                                />
                              </v-col>
                            </v-row>
                            <v-row dense align="center" justify="start">
                              <span v-if="hourAlert" style="color: crimson"
                                >Não são permitidos horários duplicados!</span
                              >
                            </v-row>
                            <v-row dense align="center" justify="start">
                              <v-checkbox v-model="form.accepted_eula">
                                <template v-slot:label>
                                  <span
                                    >Ao confirmar você concorda com
                                    <a
                                      target="_blank"
                                      href="/termos"
                                      @click.stop
                                      >termos e condiçoes de uso.</a
                                    ></span
                                  >
                                </template>
                              </v-checkbox>
                            </v-row>
                          </v-card-text>
                        </v-stepper-content>
                      </v-stepper>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    outlined
                    @click="prevStep"
                    x-large
                    class="grey--text fill-width"
                    >Voltar</v-btn
                  >
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    @click="nextStep"
                    color="#B51F57"
                    class="white--text"
                    x-large
                    :disabled="step === 5 && subStep === 2 && !validateTable()"
                    :loading="loading"
                    >{{
                      step === 5 && subStep === 2 ? "Concluir" : "Avançar"
                    }}</v-btn
                  >
                </div>
              </v-col>
            </v-card-actions>
            <div class="d-flex align-center justify-center">
              <CopyRight />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <SuccessRegister module="partner" />
    </v-container>
  </v-app>
</template>
<script>
import addressAPI from "@/shared/addressApi";
import partnerApi from "@/shared/pitchPartnerApi";
import CopyRight from "@/components/CopyRight.vue";
import WeeklyTable from "@/components/connect/WeeklyTable.vue";
import { differenceInYears, parse, isValid, isBefore } from "date-fns";
import SuccessRegister from "@/components/connect/SuccessRegistered.vue";
import { cpf } from "cpf-cnpj-validator";

export default {
  components: { CopyRight, SuccessRegister, WeeklyTable },
  data() {
    return {
      disableCheckInstitutions: false,
      disableCheckExperience: false,
      disableCheckExperienceAbroad: false,
      disableCert: false,
      hourAlert: false,
      valid: false,
      birthDate: null,
      registering: true,
      lockCertificationBox: false,
      step: 1,
      subStep: 1,
      loading: false,
      loadingAddress: false,
      readOnly: true,
      password: "",
      showPassword: false,
      displayError: false,
      isUniqueEmail: false,
      emailMessage: null,
      errorMessage: "",
      ddi: "55",
      legalGuardianddi: "55",
      form: {
        fullName: null,
        underAge: null,
        birthDate: null,
        age: null,
        email: null,
        phone: null,
        document: null,
        docType: null,
        cnpj: null,
        password: null,
        accepted_eula: false,
        available: [],
        perClass: 60,
        interval: 0,
        preferedClassType: [],
        professionalExperience: {
          yearsOfExperience: null,
          institutions: [],
          teachingExperiencieAbroad: [],
          expeciality: ["other"],
          academicFormation: null,
          hasCertificate: false,
          certificateType: [],
          diferential: "",
          adminSkills: false,
        },
        motivation: {
          reason: [],
          expectation: [],
          personalExpectation: [],

          teachingPreference: ["other"],
          adaptationAvaliability: null,
          englishAreas: [],
        },
        address: {
          street: null,
          number: null,
          neighboorhood: null,
          city: null,
          province: null,
          country: "Brasil",
          complement: "",
          zipCode: null,
        },
        legalGuardian: {
          name: null,
          email: null,
          birthDate: null,
          kinship: null,
          phone: null,
          document: null,
        },
      },
      rules: {
        email: [
          (v) => !!v || "Campo obrigatório.",
          (v) => /.+@.+\..+/.test(v) || "Email inválido.",
        ],
        password: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%*#¢+§])[A-Za-z\d@$!%*#?$§-]{8,}$/.test(
              v
            ) ||
            "Senha deve ter pelo menos 8 caracteres, incluindo pelo menos uma letra maiuscula, um número e um caractere especial",
        ],
        required: [(v) => !!v || "Campo obrigatório."],
        atLeastOne: [(v) => !!v.lenght > 0 || "Selecione ao menos uma opção."],
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
        validDate: [(v) => this.validDate(v) || "Data de nascimento inválida."],
      },
      ages: [
        {
          value: "LESS_THAN_25",
          text: "Menos de 25 anos",
        },
        {
          value: "FROM_45_TO_54",
          text: "45-54 anos",
        },
        {
          value: "FROM_25_TO_34",
          text: "25-34 anos",
        },
        {
          value: "MORE_THAN_55",
          text: "Mais de 55 anos",
        },
        {
          value: "FROM_35_TO_44",
          text: "35-44 anos",
        },
      ],
      experiencesLevelsOptions: [
        { value: "LESS_THAN_2_YEARS", text: "Menos de 2 anos" },
        { value: "MORE_THAN_10_YEARS", text: "Mais de 10 anos" },
        { value: "FROM_2_TO_5_YEARS", text: "2-5 anos" },
        { value: "UNEXPERIENCED", text: "Não possuo experiência" },
        { value: "FROM_6_TO_10_YEARS", text: "6-10 anos" },
      ],
      schoolsTypesOptions: [
        { text: "Escolas de idiomas", value: "language_schools" },
        { text: "Aulas particulares", value: "particular_classes" },
        { text: "Cursos online", value: "online_courses" },
        { text: "Escolas regulares", value: "regular_schools" },
        { text: "Não possuo Experiência", value: "unexperienced" },
      ],
      teachingExperiencieAbroadOptions: [
        { value: "exchange", text: "Intercâmbio" },
        { value: "social_projects", text: "Projeto Social" },
        { value: "work", text: "Trabalho" },
        { value: "other", text: "Outro" },
        { value: "tourism", text: "Turismo" },
        { value: "unexperienced", text: "Não possuo experiência" },
      ],
      expecialityOptions: [
        { text: "Conversação", value: "conversation" },
        { text: "Organização de exame", value: "exam_creation" },
        { text: "Gramática", value: "grammar" },
        { value: "other", text: "Outro" },
        { text: "Ingês instrumental", value: "instrumental_english" },
      ],
      academicFormationOptions: [
        { text: "Ensino fundamental", value: "ELEMENTARY" },
        { text: "Mestrado", value: "MASTER_DEGREE" },
        { text: "Ensino médio", value: "HIGH_SCHOOL" },
        { text: "Doutorado", value: "PHD" },
        { text: "Ensino superior", value: "DEGREE" },
      ],
      certificatesOptions: [
        { text: "TOEFL", value: "TOEFL" },
        { text: "TOEIC", value: "TOEIC" },
        { text: "IELTS", value: "IELTS" },
        { text: "PTE", value: "PTE" },
        { text: "Cambridge", value: "CAMBRIDGE" },
        { text: "MET", value: "MET" },
        { text: "Não possuo", value: "dont_have" },
      ],
      expectationOptions: [
        { text: "Oportunidade de negócio", value: "bussiness" },
        { text: "Realização pessoal", value: "personal_growth" },
        { text: "Flexibilidade de horários", value: "flexible_hours" },
        { text: "Liberdade geográfica", value: "geographical_freedom" },
        { text: "Paixão pelo ensino", value: "love_for_teaching" },
        { text: "Outros", value: "other" },
      ],
      personalExpectationOptions: [
        { text: "Crescimento financeiro", value: "financial_growth" },
        { text: "Negócio próprio", value: "own_bussiness" },
        { text: "Desenvolvimento profissional", value: "professional_growth" },
        { text: "Outros", value: "other" },
        { text: "Flexibilidade", value: "flexibility" },
      ],
      techingPreferenceOptions: [
        { text: "Conversação", value: "conversation" },
        { text: "General english", value: "general_english" },
        { text: "Gramática", value: "grammar" },
        { text: "Personalizada", value: "personalized" },
        { text: "Instrumental", value: "instrumental" },
        { text: "Outra", value: "other" },
      ],
      adaptationOptions: [
        { text: "Totalmente de acordo", value: "AGREE" },
        { text: "Não consigo opinar agora", value: "NEUTRAL" },
        { text: "Parcialmente de acordo", value: "PARTIALY_AGREE" },
        { text: "Discordo", value: "DISAGREE" },
      ],
      parentGrades: [
        { text: "Pai/Mãe", value: 1 },
        { text: "Padrasto/Madrasta", value: 2 },
        { text: "Tio/Tia", value: 3 },
        { text: "Avô/Avó", value: 4 },
        { text: "Responsável legal", value: 5 },
        { text: "Outro", value: 6 },
      ],
      englishAreas: [
        { text: "Conversação", value: "CONVERSATION" },
        { text: "Gramática", value: "GRAMMAR" },
        { text: "Inglês instrumental", value: "INSTRUMENTAL" },
        { text: "Preparação para exames", value: "EXAMS" },
        { text: "Crianças", value: "KIDS" },
        { text: "Bussiness", value: "BUSSINESS" },
        { text: "Não possuo", value: "NONE" },
      ],
      minutes: [
        { value: 60, text: "60 minutos" },
        { value: 90, text: "90 minutos" },
      ],
      classPreference: [
        { text: "Individual", value: "INDIVIDUAL" },
        { text: "Dupla", value: "DUO" },
        { text: "Trio", value: "TRIO" },
        { text: "Quarteto ", value: "SQUAD" },
      ],
    };
  },
  methods: {
    nextStep() {
      this.displayError = false;
      if (this.step === 1) {
        if (this.$refs.form.validate())
          if (this.subStep === 4 && !this.isUniqueEmail) {
            this.emailMessage = "Este endereço de email já está em uso.";
            return;
          } else if (this.subStep === 3) {
            this.subStep = 1;
            this.step++;
          } else if (!this.form.underAge) {
            this.subStep += 2;
          } else this.nextSubStep();
      } else if (this.step === 2) {
        if (this.$refs.form.validate()) {
          if (
            this.subStep === 2 &&
            this.form.professionalExperience.institutions.length === 0
          ) {
            this.displayError = true;
            return;
          } // ajustar
          else if (
            this.subStep === 3 &&
            this.form.professionalExperience.teachingExperiencieAbroad
              .length === 0
          ) {
            this.displayError = true;
            return;
          } else if (
            this.subStep === 4 &&
            this.form.professionalExperience.certificateType.length === 0
          ) {
            this.displayError = true;
            return;
          } else if (this.subStep === 4) {
            this.subStep = 1;
            this.step++;
          } else {
            this.displayError = false;
            this.nextSubStep();
          }
        }
      } else if (this.step === 3) {
        if (this.$refs.form.validate()) {
          if (
            this.subStep === 1 &&
            this.form.motivation.expectation.length === 0
          ) {
            this.displayError = true;
            return;
          } else if (
            this.subStep === 2 &&
            this.form.motivation.personalExpectation.length === 0
          ) {
            this.displayError = true;
            return;
          } else if (this.subStep >= 2) {
            this.subStep = 1;
            this.step++;
          } else {
            this.displayError = false;
            this.nextSubStep();
          }
        }
      } else if (this.step === 4) {
        if (this.$refs.form.validate()) {
          if (
            this.subStep === 1 &&
            this.form.motivation.englishAreas.length < 1
          ) {
            this.displayError = true;
            return;
          } else {
            this.subStep = 1;
            this.step++;
          }
        }
      } else if (this.step === 5 && this.subStep === 1) {
        if (this.$refs.form.validate()) this.subStep++;
      } else {
        this.submit();
      }
    },
    prevStep() {
      if (this.step === 1 && this.subStep === 1) {
        this.$router.push({ path: "/connect" });
      } else if (this.step === 1 && this.subStep > 1) {
        this.previousSubStep();
      } else if (this.step === 2 && this.subStep === 1) {
        this.step--;
        this.subStep = 4;
      } else if (this.step === 2 && this.subStep > 1) {
        this.previousSubStep();
      } else if (this.step === 3 && this.subStep === 1) {
        this.step--;
        this.subStep = 5;
      } else if (this.step === 3 && this.subStep > 1) {
        this.previousSubStep();
      } else if (this.step === 4 && this.subStep === 1) {
        this.step--;
        this.subStep = 2;
      } else if (this.step === 4 && this.subStep > 1) {
        this.previousSubStep();
      } else if (this.step === 5) {
        this.step = 3;
        this.subStep = 3;
      }
    },
    nextSubStep() {
      this.subStep++;
    },
    previousSubStep() {
      if (this.step === 1 && this.subStep === 3 && !this.form.underAge) {
        this.subStep = 1;
      } else this.subStep--;
    },
    getAddressByZipCode() {
      if (this.form.address.zipCode) {
        this.loadingAddress = true;
        addressAPI
          .getAddresByZipCode(this.form.address.zipCode)
          .then(async (res) => {
            this.$refs.streetInput.handleInput(res.data.address);
            this.$refs.neighboorhoodInput.handleInput(res.data.district);
            this.$refs.cityInput.handleInput(res.data.city);
            this.$refs.stateInput.handleInput(res.data.state);
            this.readOnly = false;
            this.loadingAddress = false;
          })
          .catch(() => {
            this.loadingAddress = false;
            this.readOnly = false;
          });
      }
    },
    async submit() {
      this.loading = true;
      this.form.available = await this.$refs.weeklyTable.getData();
      this.form.phone = this.form.phone
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll("+", "");
      partnerApi
        .signUp(this.form)
        .then(() => {
          this.registering = false;
        })
        .catch(() => {
          this.loading = false;
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro inesperado, tente novamente mais tarde.",
            type: 1,
          });
        });
    },
    insertTableData(data) {
      this.form.available = data;
    },
    verifyDuplicated(horarios) {
      const seen = new Set();
      let hasDuplicated = false;
      horarios.filter((horario) => {
        const chave = `${horario.weekDay}-${horario.from}-${horario.to}`;
        if (seen.has(chave)) {
          hasDuplicated = true;
          return true;
        }
        seen.add(chave);
        return false;
      });
      return hasDuplicated;
    },
    validateTable() {
      if (
        this.step === 5 &&
        this.form.accepted_eula &&
        this.form.available.length > 0
      ) {
        if (!this.verifyDuplicated(this.form.available)) {
          return true;
        }
        this.hourAlert = true;
        return false;
      }
      return false;
    },
    checkEmail(email) {
      partnerApi
        .validateEmail({ email })
        .then((res) => {
          if (res.data.result) this.emailMessage = "Email já registrado";
          else {
            this.emailMessage = "";
            this.isUniqueEmail = true;
          }
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro inesperado, tente novamente mais tarde.",
            type: 1,
          });
        });
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
    validDate(d) {
      const inputedDate = parse(d, "dd/MM/yyyy", new Date());
      return isValid(inputedDate) && isBefore(inputedDate, new Date());
    },
  },
  watch: {
    password(value) {
      if (value !== this.form.password) {
        this.errorMessage = "As senhas devem ser iguais.";
      } else {
        this.errorMessage = "";
      }
    },
    birthDate(value) {
      if (value) {
        try {
          const birthDate = parse(value, "dd/MM/yyyy", new Date());
          this.form.birthDate = birthDate;
          const difference = differenceInYears(new Date(), birthDate);
          this.form.age = difference;
          if (difference < 18) {
            this.form.underAge = true;
          } else {
            this.form.underAge = false;
          }
        } catch (e) {
          return e;
        }
      }
    },
    "form.professionalExperience.yearsOfExperience": {
      handler(value) {
        if (!value) {
          this.disableCheckInstitutions = false;
        }
        if (value && value.toUpperCase === "UNEXPERIENCED") {
          this.disableCheckInstitutions = true;
          this.form.professionalExperience.institutions = [
            this.schoolsTypesOptions.find(
              (school) => school.value.toUpperCase() === "UNEXPERIENCED"
            ).value,
          ];
          this.form.professionalExperience.teachingExperiencieAbroad = [
            this.teachingExperiencieAbroadOptions.find(
              (school) => school.value.toUpperCase() === "UNEXPERIENCED"
            ).value,
          ];
          this.form.professionalExperience.institutions = ["unexperienced"];
        }
      },
      deep: true,
    },
    "form.professionalExperience.teachingExperiencieAbroad": {
      handler(value) {
        if (value.length === 0) {
          this.disableCheckExperienceAbroad = false;
        }
        if (value.length > 1 && value.includes("unexperienced")) {
          this.disableCheckExperienceAbroad = true;
          this.form.professionalExperience.teachingExperiencieAbroad = [
            "unexperienced",
          ];
        }
      },
      deep: true,
    },
    "form.professionalExperience.institutions": {
      handler(value) {
        if (value.length === 0) {
          this.disableCheckInstitutions = false;
        }
        if (value.length > 1 && value.includes("unexperienced")) {
          this.form.professionalExperience.institutions = ["unexperienced"];
          this.disableCheckExperience = true;
        }
      },
      deep: true,
    },
    "form.professionalExperience.certificateType": {
      handler(value) {
        if (value.length === 0) {
          this.disableCheckInstitutions = false;
        }
        if (value.length > 1 && value.includes("dont_have")) {
          this.form.professionalExperience.certificateType = ["dont_have"];
          this.disableCheckExperience = true;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.fill-height {
  height: 100vh;
}

.left-side {
  background-image: url("../../../assets/images/connect/partner/background-min.webp");
  background-size: cover;
  background-position: center;
  color: white;

  h1 {
    margin-top: 15vh;
  }
}

.right-side {
  padding: 24px;
  display: flex;
}

.form-card {
  width: 100%;
  height: 100%;
}

.primary900 {
  color: #6b1233;
}

.primary700 {
  color: #b51f57;
}

strong {
  font-size: 16px;
}
</style>
